export default __webpack_public_path__ + "static/media/icon-Forms.66031ff9.svg";